module.exports = __webpack_public_path__ + "img/day7.1c30dc63.jpeg";